import { render, staticRenderFns } from "./PbProxyNotification.vue?vue&type=template&id=176e128e&"
import script from "./PbProxyNotification.vue?vue&type=script&lang=js&"
export * from "./PbProxyNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports